var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20036 5.16665V3.83331H10.867V5.16665H21.5337V3.83331H24.2004V5.16665H26.867C27.9716 5.16665 28.867 6.06208 28.867 7.16665V27.1666C28.867 28.2712 27.9716 29.1666 26.867 29.1666H5.53369C4.42912 29.1666 3.53369 28.2712 3.53369 27.1666V7.16665C3.53369 6.06208 4.42912 5.16665 5.53369 5.16665H8.20036ZM8.20036 7.83331H6.20036V13.8333H26.2004V7.83331H24.2004V9.16665H21.5337V7.83331H10.867V9.16665H8.20036V7.83331ZM26.2004 16.5H6.20036V26.5H26.2004V16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDashboard);
export default __webpack_public_path__ + "static/media/calendar-dashboard.186d5d00b93a42a05e3a9d6363097066.svg";
export { ForwardRef as ReactComponent };